import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const accordionStyles = tv({
    slots: {
        root: `
      iris:grid
      iris:w-full
      iris:gap-(--comp-space-padding-accordion-contained)
    `,
        item: ``,
        trigger: `
      iris:group
      iris:flex
      iris:min-h-(--comp-size-height-accordion)
      iris:w-full
      iris:cursor-pointer
      iris:items-center
      iris:justify-between
      iris:py-(--comp-space-padding-accordion-header-vertical)
      iris:text-left
      iris:font-(family-name:--comp-type-font-accordion-title)
      iris:font-[var(--comp-type-weight-accordion-title)]
      iris:transition-all
      iris:duration-(--comp-motion-duration-accordion-state)
      iris:ease-(--comp-motion-easing-accordion)
    `,
        triggerContent: `
      iris:flex
      iris:w-full
      iris:items-center
      iris:gap-(--comp-space-gap-accordion-icon)
      iris:leading-(--base-type-leading-tight)
    `,
        icon: `
      iris:size-(--comp-size-icon-accordion)
      iris:shrink-0
      iris:place-self-center
      iris:transition-transform
      iris:group-data-[state=closed]:duration-(--comp-motion-duration-accordion-collapse)
      iris:group-data-[state=closed]:ease-(--comp-motion-easing-accordion)
      iris:group-data-[state=open]:rotate-180
      iris:group-data-[state=open]:transform
      iris:group-data-[state=open]:duration-(--comp-motion-duration-accordion-expand)
      iris:group-data-[state=open]:ease-(--comp-motion-easing-accordion)
    `,
        iconContainer: `
      iris:flex
      iris:size-(--comp-size-box-accordion-icon-container)
      iris:items-center
      iris:justify-center
      iris:rounded-(--comp-size-radius-accordion-icon)
      iris:border
      iris:border-(--comp-color-border-accordion-icon-container)
      iris:bg-(--comp-color-background-accordion-icon-uncontained-rest)
    `,
        contentWrapper: `
      iris:space-y-(--comp-space-gap-accordion-slot)
      iris:overflow-hidden
      iris:font-(family-name:--comp-type-font-accordion-panel-text)
      iris:text-(length:--comp-type-size-accordion-panel-text)
      iris:font-(--comp-type-weight-accordion-panel-text)!
      iris:data-[state=closed]:[animation:accordionSlideUp_var(--comp-motion-duration-accordion-collapse)_var(--comp-motion-easing-accordion)_forwards]
      iris:data-[state=open]:[animation:accordionSlideDown_var(--comp-motion-duration-accordion-expand)_var(--comp-motion-easing-accordion)_forwards]
    `,
        content: `
      iris:pt-(--comp-space-padding-accordion-content-top)
      iris:pb-(--comp-space-padding-accordion-content-bottom)
    `,
        additionalLabel: `
      iris:ml-(--base-space-px-12)
      iris:text-right
      iris:font-(family-name:--comp-type-font-accordion-label)
      iris:text-(length:--comp-type-size-accordion-label-mobile)
      iris:leading-(--base-type-leading-normal)
      iris:font-[var(--comp-type-weight-accordion-label)]
      iris:whitespace-nowrap
      iris:md:text-(length:--comp-type-size-accordion-label-desktop)
    `,
    },
    variants: {
        variant: {
            uncontained: {
                trigger: `
          iris:pr-(--comp-space-padding-accordion-uncontained-icon)
          iris:pl-(--comp-space-padding-accordion-uncontained)
          iris:text-(length:--comp-type-size-accordion-title-uncontained-mobile)
          iris:md:text-(length:--comp-type-size-accordion-title-uncontained-desktop)
        `,
                content: `iris:px-(--comp-space-padding-accordion-uncontained)`,
            },
            contained: {
                trigger: `
          iris:rounded-(--comp-size-radius-accordion-contained)
          iris:pr-(--comp-space-padding-accordion-contained-icon)
          iris:pl-(--comp-space-padding-accordion-contained)
          iris:text-(length:--comp-type-size-accordion-title-contained-mobile)
          iris:focus-visible:outline-1
          iris:md:text-(length:--comp-type-size-accordion-title-contained-desktop)
        `,
                content: `iris:px-(--comp-space-padding-accordion-contained)`,
            },
        },
        inverse: {
            false: {
                trigger: focusStyles.defaultWithOutline,
                additionalLabel: `iris:text-(--comp-color-content-accordion-label-contained)`,
                iconContainer: `
          iris:border-(--comp-color-border-accordion-icon-container)
          iris:bg-(--comp-color-background-accordion-icon-uncontained-rest)
          iris:hover:bg-(--comp-color-background-accordion-icon-contained-hover)
          iris:active:bg-(--comp-color-background-accordion-icon-contained-pressed)
        `,
            },
            true: {
                trigger: focusStyles.inverseWithOutline,
                additionalLabel: `iris:text-(--comp-color-content-accordion-label-uncontained-inverse)`,
                iconContainer: `
          iris:border-(--comp-color-border-accordion-icon-container-inverse)
          iris:bg-(--comp-color-background-accordion-icon-uncontained-inverse-rest)
          iris:hover:bg-(--comp-color-background-accordion-icon-contained-hover)
          iris:active:bg-(--comp-color-background-accordion-icon-contained-pressed)
        `,
            },
        },
        hasAdditionalLabel: {
            true: {},
            false: {
                iconContainer: `iris:ml-(--base-space-px-12)`,
            },
        },
    },
    compoundVariants: [
        // Contained variants
        {
            variant: "contained",
            inverse: false,
            hasAdditionalLabel: false,
            class: {
                root: ``,
                item: `
          iris:rounded-(--comp-size-radius-accordion-contained) iris:border
          iris:border-(--comp-color-border-accordion-contained)
          iris:bg-(--comp-color-background-accordion-contained-rest)
        `,
                trigger: `
          iris:bg-(--comp-color-background-accordion-contained-rest)
          iris:text-(--comp-color-content-accordion-title-contained-rest)
          iris:hover:bg-(--comp-color-background-accordion-contained-hover)
          iris:hover:text-(--comp-color-content-accordion-title-contained-hover)
          iris:focus-visible:outline-(--comp-color-border-accordion-contained)
          iris:active:bg-(--comp-color-background-accordion-contained-pressed)
          iris:active:text-(--comp-color-content-accordion-title-contained-pressed)
        `,
                icon: `iris:text-(--comp-color-content-accordion-icon)`,
                content: `iris:text-(--comp-color-content-accordion-panel-text-contained)`,
            },
        },
        {
            variant: "contained",
            inverse: true,
            hasAdditionalLabel: false,
            class: {
                root: ``,
                item: `
          iris:rounded-(--comp-size-radius-accordion-contained) iris:border
          iris:border-(--comp-color-border-accordion-contained-inverse)
          iris:bg-(--comp-color-background-accordion-contained-inverse-rest)
        `,
                trigger: `
          iris:bg-(--comp-color-background-accordion-contained-inverse-rest)
          iris:text-(--comp-color-content-accordion-title-contained-inverse-rest)
          iris:hover:bg-(--comp-color-background-accordion-contained-inverse-hover)
          iris:hover:text-(--comp-color-content-accordion-title-contained-inverse-hover)
          iris:focus-visible:outline-(--comp-color-border-accordion-contained)
          iris:active:bg-(--comp-color-background-accordion-contained-inverse-pressed)
          iris:active:text-(--comp-color-content-accordion-title-contained-inverse-pressed)
        `,
                icon: `iris:text-(--comp-color-content-accordion-icon-inverse)`,
                content: `iris:text-(--comp-color-content-accordion-panel-text-contained-inverse)`,
            },
        },
        // Uncontained variants
        {
            variant: "uncontained",
            inverse: false,
            hasAdditionalLabel: false,
            class: {
                root: ``,
                item: `
          iris:rounded-(--comp-size-radius-accordion-contained)
          iris:bg-(--comp-color-background-accordion-uncontained-rest)
        `,
                trigger: `
          iris:bg-(--comp-color-background-accordion-uncontained-rest)
          iris:text-(--comp-color-content-accordion-title-uncontained-rest)
          iris:hover:bg-(--comp-color-background-accordion-uncontained-hover)
          iris:hover:text-(--comp-color-content-accordion-title-uncontained-hover)
          iris:active:bg-(--comp-color-background-accordion-uncontained-pressed)
          iris:active:text-(--comp-color-content-accordion-title-uncontained-hover)
        `,
                icon: `iris:text-(--comp-color-content-accordion-icon)`,
                content: `iris:text-(--comp-color-content-accordion-panel-text-uncontained)`,
            },
        },
        {
            variant: "uncontained",
            inverse: true,
            hasAdditionalLabel: false,
            class: {
                root: ``,
                item: `
          iris:rounded-(--comp-size-radius-accordion-contained)
          iris:bg-(--comp-color-background-accordion-uncontained-inverse-rest)
        `,
                trigger: `
          iris:bg-(--comp-color-background-accordion-uncontained-inverse-rest)
          iris:text-(--comp-color-content-accordion-title-uncontained-inverse-rest)
          iris:hover:bg-(--comp-color-background-accordion-uncontained-inverse-hover)
          iris:active:bg-(--comp-color-background-accordion-uncontained-inverse-pressed)
        `,
                icon: `iris:text-(--comp-color-content-accordion-icon-inverse)`,
                content: `iris:text-(--comp-color-content-accordion-panel-text-uncontained-inverse)`,
            },
        },
        {
            variant: "uncontained",
            inverse: true,
            hasAdditionalLabel: true,
            class: {
                root: ``,
                item: `
          iris:rounded-(--comp-size-radius-accordion-contained)
          iris:border-(--comp-color-border-divider-inverse)
          iris:bg-(--comp-color-background-accordion-uncontained-inverse-rest)
        `,
                trigger: `
          iris:bg-(--comp-color-background-accordion-uncontained-inverse-rest)
          iris:pr-(--comp-space-padding-accordion-uncontained)
          iris:pl-(--comp-space-padding-accordion-uncontained-icon)
          iris:text-(--comp-color-content-accordion-title-uncontained-inverse-rest)
          iris:hover:bg-(--comp-color-background-accordion-uncontained-inverse-hover)
          iris:active:bg-(--comp-color-background-accordion-uncontained-inverse-pressed)
        `,
                icon: `iris:text-(--comp-color-content-accordion-icon-inverse)`,
                content: `iris:text-(--comp-color-content-accordion-panel-text-uncontained-inverse)`,
            },
        },
        {
            variant: "uncontained",
            inverse: false,
            hasAdditionalLabel: true,
            class: {
                root: ``,
                item: `
          iris:border-(--comp-color-border-divider-inverse)
          iris:bg-(--comp-color-background-accordion-uncontained-rest)
        `,
                trigger: `
          iris:bg-(--comp-color-background-accordion-uncontained-rest)
          iris:pr-(--comp-space-padding-accordion-uncontained)
          iris:pl-(--comp-space-padding-accordion-uncontained-icon)
          iris:text-(--comp-color-content-accordion-title-uncontained-rest)
          iris:hover:bg-(--comp-color-background-accordion-uncontained-hover)
          iris:hover:text-(--comp-color-content-accordion-title-uncontained-hover)
          iris:active:bg-(--comp-color-background-accordion-uncontained-pressed)
          iris:active:text-(--comp-color-content-accordion-title-uncontained-pressed)
        `,
                icon: `iris:text-(--comp-color-content-accordion-icon)`,
                content: `iris:text-(--comp-color-content-accordion-panel-text-uncontained)`,
            },
        },
        {
            variant: "contained",
            inverse: false,
            hasAdditionalLabel: true,
            class: {
                root: ``,
                item: `
          iris:rounded-(--comp-size-radius-accordion-contained) iris:border
          iris:border-(--comp-color-border-accordion-contained)
          iris:bg-(--comp-color-background-accordion-contained-rest)
        `,
                trigger: `
          iris:bg-(--comp-color-background-accordion-contained-rest)
          iris:pr-(--comp-space-padding-accordion-contained)
          iris:pl-(--comp-space-padding-accordion-contained-icon)
          iris:text-(--comp-color-content-accordion-title-contained-rest)
          iris:hover:bg-(--comp-color-background-accordion-contained-hover)
          iris:hover:text-(--comp-color-content-accordion-title-contained-hover)
          iris:focus-visible:outline-(--comp-color-border-accordion-contained)
          iris:active:bg-(--comp-color-background-accordion-contained-pressed)
          iris:active:text-(--comp-color-content-accordion-title-contained-pressed)
        `,
                icon: `iris:text-(--comp-color-content-accordion-icon)`,
                content: `iris:text-(--comp-color-content-accordion-panel-text-contained)`,
            },
        },
        {
            variant: "contained",
            inverse: true,
            hasAdditionalLabel: true,
            class: {
                root: ``,
                item: `
          iris:rounded-(--comp-size-radius-accordion-contained) iris:border
          iris:border-(--comp-color-border-accordion-contained-inverse)
          iris:bg-(--comp-color-background-accordion-contained-inverse-rest)
        `,
                trigger: `
          iris:bg-(--comp-color-background-accordion-contained-inverse-rest)
          iris:pr-(--comp-space-padding-accordion-contained)
          iris:pl-(--comp-space-padding-accordion-contained-icon)
          iris:text-(--comp-color-content-accordion-title-contained-inverse-rest)
          iris:hover:bg-(--comp-color-background-accordion-contained-inverse-hover)
          iris:hover:text-(--comp-color-content-accordion-title-contained-inverse-hover)
          iris:focus-visible:outline-(--comp-color-border-accordion-contained-inverse)
          iris:active:bg-(--comp-color-background-accordion-contained-inverse-pressed)
          iris:active:text-(--comp-color-content-accordion-title-contained-inverse-pressed)
        `,
                icon: `iris:text-(--comp-color-content-accordion-icon-inverse)`,
                content: `iris:text-(--comp-color-content-accordion-panel-text-contained-inverse)`,
            },
        },
    ],
    defaultVariants: {
        variant: "contained",
        inverse: false,
        hasAdditionalLabel: false,
    },
});

export { accordionStyles as default };
